/* Bouncewear predictive search overlay (psrch). Uses Shopify predictive search (/search/suggest) rendered by
   sections/bwx-psrch-results.liquid, so Search & Discovery synonyms, boosts and filters apply. */
(function () {
  'use strict';

  var KEY = 'bwx_psrch_recent';
  var MAX = 12;
  var SHOW = 6;

  function store() {
    try { return window.localStorage; } catch (e) { return null; }
  }
  function readRecent() {
    try {
      var s = store();
      var v = s ? JSON.parse(s.getItem(KEY) || '[]') : [];
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function writeRecent(a) {
    try {
      var s = store();
      if (!s) return;
      if (!a.length) s.removeItem(KEY); else s.setItem(KEY, JSON.stringify(a.slice(0, MAX)));
    } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var HANDLE_RE = /^[a-z0-9][a-z0-9\-_.%]*$/i;
  var IMG_RE = /^(https?:)?\/\/[^\s"'<>]+$/i;

  function track(root) {
    try {
      var h = root.getAttribute('data-ph');
      if (!h || !HANDLE_RE.test(h)) return;
      var img = root.getAttribute('data-pi') || '';
      var list = readRecent().filter(function (x) { return x && x.h && x.h !== h; });
      list.unshift({ h: h, i: IMG_RE.test(img) ? img : '', t: root.getAttribute('data-pt') || '' });
      writeRecent(list);
    } catch (e) {}
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function init(root) {
    if (!root || root.__psrch) return;
    root.__psrch = true;
    track(root);

    /* Escape the header (sticky/transform) so the overlay can be fixed to the viewport. */
    try { if (root.parentNode !== document.body) document.body.appendChild(root); } catch (e) {}

    var on = root.getAttribute('data-on') === '1';
    var input = root.querySelector('input[type="search"]');
    var form = root.querySelector('[data-psrch-form]');
    var res = root.querySelector('[data-psrch-results]');
    var empty = root.querySelector('[data-psrch-empty]');
    var body = root.querySelector('[data-psrch-body]');
    var status = root.querySelector('[data-psrch-status]');
    var clearBtn = root.querySelector('[data-psrch-clear]');
    var closeBtn = root.querySelector('.js-search-modal-close');
    var recentWrap = root.querySelector('[data-psrch-recent]');
    var recentGrid = root.querySelector('[data-psrch-recent-grid]');
    var recentClear = root.querySelector('[data-psrch-recent-clear]');
    if (!input || !res || !empty) return;

    var base = root.getAttribute('data-url') || '/search/suggest';
    var surl = root.getAttribute('data-search-url') || '/search';
    var sec = root.getAttribute('data-section') || 'bwx-psrch-results';
    var prefix = root.getAttribute('data-root') || '';
    var current = root.getAttribute('data-ph') || '';
    var t = {
      all: root.getAttribute('data-t-all') || '',
      allN: root.getAttribute('data-t-all-n') || '',
      all1: root.getAttribute('data-t-all-1') || '',
      results: root.getAttribute('data-t-results') || '',
      loading: root.getAttribute('data-t-loading') || ''
    };

    var cache = {};
    var counts = {};
    var fbs = {};
    var ctrl = null;
    var seq = 0;
    var active = -1;

    function isOpen() { return root.classList.contains('m-search-modal--visible'); }
    function enc(k) { return encodeURIComponent(k); }
    function suggestUrl(q) {
      return base + '?q=' + enc(q) +
        '&' + enc('resources[type]') + '=query,product,collection,page,article' +
        '&' + enc('resources[limit]') + '=10' +
        '&' + enc('resources[limit_scope]') + '=each' +
        '&' + enc('resources[options][fields]') + '=title,product_type,variants.title,vendor,variants.sku' +
        '&section_id=' + enc(sec);
    }
    function countUrl(q) {
      return surl + '?q=' + enc(q) + '&' + enc('options[prefix]') + '=last&section_id=' + enc(sec);
    }

    function options() { return res.hidden ? [] : Array.prototype.slice.call(res.querySelectorAll('[role="option"]')); }
    function setActive(i) {
      var opts = options();
      opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
      if (i < 0 || i >= opts.length) {
        active = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      active = i;
      opts[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[i].id);
      try { opts[i].scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }

    function renderRecent() {
      if (!recentWrap || !recentGrid) return;
      var list = readRecent().filter(function (x) {
        return x && x.h && HANDLE_RE.test(x.h) && x.h !== current;
      }).slice(0, SHOW);
      if (!list.length) {
        recentWrap.hidden = true;
        recentGrid.innerHTML = '';
        return;
      }
      recentGrid.innerHTML = list.map(function (x) {
        var img = x.i && IMG_RE.test(x.i) ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" width="300" height="300">' : '';
        return '<a class="psrch__rv" href="' + esc(prefix + '/products/' + x.h) + '">' +
          '<span class="psrch__rv-img">' + img + '</span>' +
          '<span class="psrch__rv-t">' + esc(x.t || x.h) + '</span></a>';
      }).join('');
      recentWrap.hidden = false;
    }

    function showEmpty() {
      seq++;
      if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
      res.hidden = true;
      res.innerHTML = '';
      empty.hidden = false;
      setActive(-1);
      input.setAttribute('aria-expanded', 'false');
      if (clearBtn) clearBtn.hidden = true;
      root.classList.remove('psrch--busy');
      renderRecent();
    }

    function shows(r, key) {
      return !!r && (r.getAttribute('data-psrch-terms') || '').trim().toLowerCase().replace(/\s+/g, ' ') === key;
    }

    function applyCount(n, key) {
      if (!shows(res.querySelector('.psrch-r'), key)) return;
      var btn = res.querySelector('[data-psrch-all]');
      if (!btn || typeof n !== 'number' || isNaN(n)) return;
      var txt = n === 1 ? t.all1 : (n > 1 ? t.allN.replace('[n]', n) : t.all);
      if (txt) btn.textContent = txt;
    }

    function numberOptions() {
      var opts = res.querySelectorAll('[role="option"]');
      for (var i = 0; i < opts.length; i++) {
        opts[i].id = 'psrch-opt-' + i;
        opts[i].setAttribute('aria-selected', 'false');
      }
      active = -1;
      input.removeAttribute('aria-activedescendant');
    }

    /* Predictive search returned no products: show the top products of the full search (count request). */
    function applyFallback(key, q) {
      var fb = fbs[key];
      var r = res.querySelector('.psrch-r');
      if (!fb || !r || !shows(r, key) || r.querySelector('.psrch-r__p')) return;
      if (r.classList.contains('psrch-r--none')) {
        r.classList.remove('psrch-r--none');
        r.innerHTML = '<div class="psrch-r__b">' + fb + '<a class="psrch-r__all" href="' +
          esc(surl + '?q=' + enc(q) + '&options%5Bprefix%5D=last') +
          '" role="option" aria-selected="false" data-psrch-all>' + esc(t.all) + '</a></div>';
      } else {
        var b = r.querySelector('.psrch-r__b');
        if (!b) return;
        b.insertAdjacentHTML('afterbegin', fb);
      }
      numberOptions();
    }

    function renderResults(html, key, q) {
      res.innerHTML = html;
      numberOptions();
      if (fbs.hasOwnProperty(key)) applyFallback(key, q);
      empty.hidden = true;
      res.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      root.classList.remove('psrch--busy');
      if (body) body.scrollTop = 0;
      if (counts.hasOwnProperty(key)) applyCount(counts[key], key);
      if (status) {
        var r = res.querySelector('.psrch-r');
        var tot = r ? parseInt(r.getAttribute('data-psrch-total'), 10) || 0 : 0;
        status.textContent = t.results.replace('[n]', counts.hasOwnProperty(key) ? counts[key] : tot);
      }
    }

    function run() {
      var q = (input.value || '').trim();
      if (clearBtn) clearBtn.hidden = !input.value;
      if (!q) { showEmpty(); return; }
      if (!on) return;
      var key = q.toLowerCase().replace(/\s+/g, ' ');
      var my = ++seq;
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var opt = { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined };

      if (cache.hasOwnProperty(key)) {
        renderResults(cache[key], key, q);
      } else {
        root.classList.add('psrch--busy');
        fetch(suggestUrl(q), opt).then(function (r) {
          if (!r.ok) throw new Error('psrch ' + r.status);
          return r.text();
        }).then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          var el = doc.querySelector('.psrch-r');
          var html = el ? el.outerHTML : '';
          cache[key] = html;
          if (my === seq) renderResults(html, key, q);
        }).catch(function (e) {
          if (e && e.name === 'AbortError') return;
          if (my === seq) root.classList.remove('psrch--busy');
        });
      }

      if (!counts.hasOwnProperty(key)) {
        fetch(countUrl(q), opt).then(function (r) {
          if (!r.ok) throw new Error('psrch count ' + r.status);
          return r.text();
        }).then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          var c = doc.querySelector('[data-psrch-count]');
          if (!c) return;
          counts[key] = parseInt(c.getAttribute('data-psrch-count'), 10) || 0;
          var fb = doc.querySelector('[data-psrch-fb]');
          fbs[key] = fb ? fb.outerHTML : '';
          if (my === seq && !res.hidden) {
            applyFallback(key, q);
            applyCount(counts[key], key);
          }
        }).catch(function () {});
      }
    }

    var runLater = debounce(run, 220);

    input.addEventListener('input', function () {
      if (clearBtn) clearBtn.hidden = !input.value;
      if (!input.value.trim()) { showEmpty(); return; }
      runLater();
    });

    input.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        var opts = options();
        if (!opts.length) return;
        e.preventDefault();
        var n = k === 'ArrowDown' ? active + 1 : active - 1;
        if (n >= opts.length) n = 0;
        if (n < 0) n = opts.length - 1;
        setActive(n);
      } else if (k === 'Enter') {
        var o = options()[active];
        if (o && o.href) {
          e.preventDefault();
          window.location.href = o.href;
        }
      } else if (k === 'Escape') {
        if (active >= 0) { e.preventDefault(); e.stopPropagation(); setActive(-1); }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      e.preventDefault();
      if (closeBtn) closeBtn.click();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!(input.value || '').trim()) { e.preventDefault(); input.focus(); }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        showEmpty();
        input.focus();
      });
    }

    if (recentClear) {
      recentClear.addEventListener('click', function () {
        writeRecent([]);
        renderRecent();
        input.focus();
      });
    }

    res.addEventListener('mousemove', function (e) {
      var o = e.target.closest ? e.target.closest('[role="option"]') : null;
      if (!o) return;
      var i = options().indexOf(o);
      if (i !== active) setActive(i);
    });

    /* Open / close come from the header SearchController (class m-search-modal--visible). */
    var wasOpen = isOpen();
    try {
      new MutationObserver(function () {
        var open = isOpen();
        if (open === wasOpen) return;
        wasOpen = open;
        if (open) {
          if (!(input.value || '').trim()) showEmpty(); else run();
          setTimeout(function () { try { input.focus(); } catch (e) {} }, 60);
        } else {
          showEmpty();
        }
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}

    renderRecent();

    root.__psrchOpen = function (q) {
      if (!isOpen()) {
        var trigger = document.querySelector('.js-header-search');
        if (trigger) trigger.click();
        else { root.classList.add('m-search-modal--visible'); document.body.classList.add('no-scroll'); }
      }
      if (typeof q === 'string') {
        input.value = q;
        run();
      }
      try { input.focus(); } catch (e) {}
    };
  }

  function boot() {
    var roots = document.querySelectorAll('[data-psrch]');
    /* Theme editor re-render: keep only the newest overlay. */
    if (roots.length > 1) {
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].__psrch && roots[i].parentNode === document.body) {
          try { roots[i].parentNode.removeChild(roots[i]); } catch (e) {}
        }
      }
      roots = document.querySelectorAll('[data-psrch]');
    }
    for (var j = 0; j < roots.length; j++) init(roots[j]);
  }

  window.bwxPsrch = {
    open: function (q) {
      var r = document.querySelector('[data-psrch]');
      if (r && r.__psrchOpen) r.__psrchOpen(q);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
